export default __webpack_public_path__ + "static/media/stop-red.a7d4518f.svg";